/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faChevronLeft,
  faCalendarAlt,
  faWarning,
} from '@fortawesome/free-solid-svg-icons';
import {
  Tab, Tabs, TabList, TabPanel,
} from 'react-tabs';
import moment from 'moment';
import Swal from 'sweetalert2';
import { formatCount, isValidName } from '../../components/Validators';
import Search from '../../components/Search';
import LoadingModal from '../../components/LoadingModal';
import logoImg from '../../assets/images/logo.png';
import {
  getAllMccFarmersPendingPlantSideRequestDetailsByType, getMccFarmersCompletedPlantSideRequestDetailsByType, searchMccFarmersPendingPlantSideRequestDetailsByType, searchMccFarmersCompletedPlantSideRequestDetailsByType, filterMccFarmersPlantSidePendingRequests, filterMccFarmersPlantSideCompletedRequests,
  getCountMccFarmersDigitalRegistraion,
} from '../../store/modules/newUser/actions';
import {
  selectIsLoading,
  selectPendingMccFarmersData,
  selectCompletedMccFarmersData,
  selectMccFarmersCountData,
} from '../../store/modules/newUser/selectors';
import ModalForFilter from '../../components/ModalForFilter';
import './mccFarmerListViewPage.scss';
import withScreenRefreshDetection from '../../utils/withScreenRefreshDetection';

const MccFarmerListViewPage = (props) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [query, setQuery] = useState(null);
  const [showModalForFilter, setshowModalForFilter] = useState(false);
  const [dates, setDates] = useState({
    startDate: null,
    endDate: null,
  });

  const dispatch = useDispatch();
  const upcoming = useSelector((state) => selectPendingMccFarmersData(state));
  const pastHeld = useSelector((state) => selectCompletedMccFarmersData(state));
  const count = useSelector((state) => selectMccFarmersCountData(state));
  const isLoading = useSelector((state) => selectIsLoading(state));
  const filterAppliedForWaitingUsers = localStorage.getItem(
    'isFilterAppliedForWaitingUsers',
  );
  const filterAppliedForCompletedUsers = localStorage.getItem(
    'isFilterAppliedForCompletedUsers',
  );
  const values = {
    page: 1,
    limit: 10,
  };

  const fetchDetailsBasedOnStates = (state) => {
    if (tabIndex === 1) {
      dispatch(getMccFarmersCompletedPlantSideRequestDetailsByType(values));
    } else {
      dispatch(getAllMccFarmersPendingPlantSideRequestDetailsByType());
    }
  };
  const handleConfirmPendingUsers = () => {
    localStorage.removeItem('isFilterAppliedForWaitingUsers');
    fetchDetailsBasedOnStates();
  };

  const handleConfirmCompletedUsers = () => {
    localStorage.removeItem('isFilterAppliedForCompletedUsers');
    fetchDetailsBasedOnStates();
  };
  useEffect(() => {
    dispatch(getCountMccFarmersDigitalRegistraion('mccFarmer'));
  }, [dispatch]);

  useEffect(() => {
    if (tabIndex === 0 && filterAppliedForWaitingUsers) {
      Swal.fire({
        icon: 'warning',
        title:
          'Filter applied for pending users, do you want to continue anyway?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#229945',
        cancelButtonColor: '#f26868',
        confirmButtonText: 'Continue',
        cancelButtonText: 'Remove Filter',
        toast: true,
      }).then((result) => {
        if (result.isDismissed) {
          handleConfirmPendingUsers();
        }
      });
    } else if (tabIndex === 1 && filterAppliedForCompletedUsers) {
      Swal.fire({
        icon: 'warning',
        title:
          'Filter applied for completed users, do you want to continue anyway?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#229945',
        cancelButtonColor: '#f26868',
        confirmButtonText: 'Continue',
        cancelButtonText: 'Remove Filter',
        toast: true,
      }).then((result) => {
        if (result.isDismissed) {
          handleConfirmCompletedUsers();
        }
      });
    } else {
      fetchDetailsBasedOnStates();
    }
  }, [tabIndex, filterAppliedForWaitingUsers, filterAppliedForCompletedUsers]);
  useEffect(() => {
    if (props?.isRefreshed) {
      localStorage.removeItem('filterAppliedForCompletedUsers');
      localStorage.removeItem('isFilterAppliedForWaitingUsers');
    }
  }, [props?.isRefreshed]);
  const handleChange = (event) => {
    const { value } = event.target;
    setQuery(value);
  };

  const nextUpcomingPage = (page) => {
    dispatch(getAllMccFarmersPendingPlantSideRequestDetailsByType(page));
  };

  const previousUpcomingPage = (page) => {
    dispatch(getAllMccFarmersPendingPlantSideRequestDetailsByType(page));
  };

  const nextPastHeldPage = (page) => {
    const nextPage = {
      page,
      limit: 10,
    };
    dispatch(getMccFarmersCompletedPlantSideRequestDetailsByType(nextPage));
  };

  const previousPastHeldPage = (page) => {
    const previousPage = {
      page,
      limit: 10,
    };
    dispatch(getMccFarmersCompletedPlantSideRequestDetailsByType(previousPage));
  };

  const handleOnSearch = async () => {
    let valueSearch;
    Swal.fire({
      toast: true,
      icon: 'warning',
      title: 'Are you in search of a phone Number?',
      showCancelButton: true,
      cancelButtonColor: '#d33',
      confirmButtonColor: 'green',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((res) => {
      if (res?.isConfirmed) {
        valueSearch = {
          phone: query,
          page: 1,
          limit: 10,

        };
      } else if (isValidName(query)) {
        valueSearch = {
          farmerName: query,
          page: 1,
          limit: 10,
        };
      }
      if (tabIndex === 0) {
        dispatch(searchMccFarmersPendingPlantSideRequestDetailsByType(valueSearch));
      } else {
        dispatch(searchMccFarmersCompletedPlantSideRequestDetailsByType(valueSearch));
      }
    });
  };
  const handleOnFilter = () => {
    setshowModalForFilter(!showModalForFilter);
  };

  const submitFilter = (e) => {
    const filterValues = {
      hpcCode: e?.hpcCode,
      fromDate: moment(e?.fromDate).format('DD/MM/YYYY'),
      page: 1,
      limit: 10,
      toDate: moment(e?.toDate).format('DD/MM/YYYY'),
    };
    if (tabIndex === 0) {
      dispatch(filterMccFarmersPlantSidePendingRequests(filterValues));
      localStorage.setItem('isFilterAppliedForWaitingUsers', true);
    } else {
      dispatch(filterMccFarmersPlantSideCompletedRequests(filterValues));
      localStorage.setItem('isFilterAppliedForCompletedUsers', true);
    }
  };
  const handleOnBackPress = () => {
    if (tabIndex === 0) {
      dispatch(getAllMccFarmersPendingPlantSideRequestDetailsByType());
    }
    dispatch(getMccFarmersCompletedPlantSideRequestDetailsByType(values));
  };
  return (
    <>
      <div className="admin-orders">
        {tabIndex === 0 && filterAppliedForWaitingUsers ? (
          <div className="filterAppliedFlag">
            <FontAwesomeIcon icon={faWarning} style={{ marginRight: 5 }} />
            In order to dynamically remove the filter that has been applied to pending users, please refresh the page.
          </div>
        ) : tabIndex === 1 && filterAppliedForCompletedUsers ? (
          <div className="filterAppliedFlag">
            <FontAwesomeIcon icon={faWarning} style={{ marginRight: 5 }} />
            In order to dynamically remove the filter that has been applied to completed users, please refresh the page.
          </div>
        ) : null}
        {/* <div className="row middle">
          <div className="col-12 col-md-3">
            <div className="summary-card warning mr-8">
              <div className="summary-card__left">
                <FontAwesomeIcon icon={faMoneyBill} className="summary-card__icon" />
              </div>
              <div className="summary-card__right">
                <span className="summary-card__label">
                  Pending Loan Request
                </span>

                <span className="summary-card__value">
                  {count ? count?.pendingLoanRequests : 0}
                </span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3">
            <div className="summary-card green mr-8">
              <div className="summary-card__left">
                <FontAwesomeIcon icon={faMoneyBill} className="summary-card__icon" />
              </div>
              <div className="summary-card__right">
                <span className="summary-card__label">
                  Finished Loan Request
                </span>

                <span className="summary-card__value">
                  {count ? count?.finsihedLoanRequests : 0}
                </span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3">
            <div className="summary-card danger mr-8">
              <div className="summary-card__left">
                <FontAwesomeIcon icon={faMoneyBill} className="summary-card__icon" />
              </div>
              <div className="summary-card__right">
                <span className="summary-card__label">
                  Rejected Loan Request
                </span>

                <span className="summary-card__value">
                  {count ? count?.rejectedLoanRequests : 0}
                </span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3">
            <div className="summary-card primary mr-8">
              <div className="summary-card__left">
                <FontAwesomeIcon icon={faMoneyBill} className="summary-card__icon" />
              </div>
              <div className="summary-card__right">
                <span className="summary-card__label">
                  Total Loan Request
                </span>

                <span className="summary-card__value">
                  {count ? count?.totalLoanRequests : 0}
                </span>
              </div>
            </div>
          </div>
        </div> */}
        <div className="row">
          <div className="col-12">
            <div className="heading">
              <p className="heading__title" onClick={handleOnBackPress}>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                />

                {' '}
                Pending Mcc Farmer Registrations
              </p>
            </div>
          </div>
        </div>

        <Tabs
          defaultIndex={0}
          selectedIndex={tabIndex}
          onSelect={(index) => setTabIndex(index)}
        >
          <TabList className="row between tab-list">
            <Tab className="col-6 tab">
              <div className={`type-card ${tabIndex === 0 ? 'selected' : ''}`}>
                Waiting for Approval
                {
                  count?.countedDigitalRegistrations?.pendingCount > 0 ? (
                    <span className="count-ui danger">
                      {formatCount(count?.countedDigitalRegistrations?.pendingCount)}
                    </span>
                  ) : null
                }
              </div>
            </Tab>
            <Tab className="col-6 tab">
              <div className={`type-card ${tabIndex === 1 ? 'selected' : ''}`}>
                Completed
                {count?.countedDigitalRegistrations?.approvedCount > 0 ? (
                  <span className="count-ui">
                    {formatCount(count?.countedDigitalRegistrations?.approvedCount)}
                  </span>
                ) : null}
              </div>
            </Tab>
          </TabList>
          <TabPanel className="appointments-tab-panel">
            {/* <div className="row middle">
              <div className="col-12 col-md-12">
                <Search value={query} onChangeText={handleChange} onSubmit={search} />
              </div>
              <div className="col-12 col-md-2">
                <div className="buttons">
                  <button type="button" className="button green">
                    <FontAwesomeIcon icon={faFileExcel} className="button__icon" />
                    Export
                  </button>
                </div>
              </div>
            </div> */}
            <div className="row middle">
              <div className="col-12 col-md-10">
                <Search
                  value={query}
                  label="Find Farmers By Name or Phone"
                  onChangeText={handleChange}
                  onSubmit={handleOnSearch}
                />
              </div>
              {/* <div className="col-12 col-md-2">
                <div className="buttons">
                  <button
                    type="button"
                    className="button green"
                    onClick={handleOnFilter}
                  >
                    <FontAwesomeIcon icon={faFilter} className="button__icon" />
                    Filter
                  </button>
                </div>
              </div> */}
            </div>
            <div className="row">
              {upcoming && upcoming.paginate
                ? upcoming.paginate.map((item) => (
                  <div className="col-12 col-lg-12">
                    <div className="card">
                      <div className="card__left">
                        <div className="card__avatar">
                          {
                            item?.profilePicture ? (<img src={item?.profilePicture} alt="order" />
                            ) : <img src={logoImg} alt="user" />

                          }
                        </div>
                        <div className="row between col-9">
                          <div className="card__text">
                            <div>
                              <span className="card__title">
                                Farmer Name :
                                {' '}
                              </span>
                              {item ? item?.farmerName : ''}
                            </div>
                            <div>
                              <span className="card__title">
                                Registration ID :
                                {' '}
                              </span>
                              {item ? item?.id : ''}
                            </div>
                            <div>
                              <span className="card__title">
                                Phone:
                                {' '}
                              </span>
                              {/* {item?.id ? item?.id : ''} */}
                              {item ? item?.phone : ''}

                            </div>
                            <div>
                              <span className="card__title">
                                Role:
                                {' '}
                              </span>
                              {/* {item?.id ? item?.id : ''} */}
                              MCC Farmer
                            </div>
                          </div>
                          <div className="card__text">
                            <div>
                              <span className="card__title">
                                User Created At :
                                {' '}
                              </span>
                              {moment(item?.createdAt).format('DD/MM/YYYY')}
                            </div>
                            <div>
                              <span className="card__title">
                                Plant Code :
                                {' '}
                              </span>
                              {item?.plantCode ?? 'N/A'}
                            </div>
                            <div>
                              <span className="card__title">
                                MCC Code :
                                {' '}
                              </span>
                              {item?.mccCode ?? 'N/A'}
                            </div>
                            <div>
                              <span className="card__title">
                                User Created Time :
                                {' '}
                              </span>
                              {moment(item?.createdAt).format('hh:mm a')}
                            </div>
                          </div>

                        </div>

                      </div>
                      <div className="card__right">
                        {item?.isNew && (
                        <span
                          className="count-ui primary"
                        >
                          NEW
                        </span>
                        )}
                        <div
                          className={`card__text--${item.farmerStatus === 'Active' ? 'success'
                            : item.farmerStatus === 'Inactive' ? 'danger' : 'primary'}`}
                        >
                          <span
                            className="card__title"
                          >
                            Status :
                            {' '}
                          </span>
                          {item.farmerStatus ?? 'Old User'}
                        </div>

                        <Link to={`/plant-admin/MccFarmerEditPage/${item?.id}`} className="card__button">View</Link>
                      </div>
                    </div>
                  </div>
                ))
                : (
                  null
                )}
              {!isLoading && !upcoming?.paginate?.length && (
              <div className="col-12 col-lg-12 d-flex-col middle">
                <div className="notFound">
                  <FontAwesomeIcon icon={faCalendarAlt} className="notFound__icon" />
                  <span className="notFound__text">No upcoming User Request found</span>
                </div>
              </div>
              )}
            </div>
            {upcoming?.paginate?.length > 0
              ? (
                <div className="row">
                  <div className="col-12 col-lg-12 d-flex-col middle">
                    <div className="pagination">
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!upcoming.Previous}
                        onClick={() => previousUpcomingPage(upcoming.Previous.page)}
                      >
                        <FontAwesomeIcon icon={faChevronLeft} className="pagination__btn__icon" />
                      </button>
                      <span className="pagination__page">
                        {upcoming.Next
                          ? upcoming.Next.page - 1
                          : upcoming.Previous
                            ? upcoming.Previous.page + 1
                            : 1}
                      </span>
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!upcoming.Next}
                        onClick={() => nextUpcomingPage(upcoming.Next.page)}
                      >
                        <FontAwesomeIcon icon={faChevronRight} className="pagination__btn__icon" />
                      </button>
                    </div>
                  </div>
                </div>
              ) : null}
          </TabPanel>
          <TabPanel className="appointments-tab-panel">
            <div className="row middle">
              <div className="col-12 col-md-10">
                <Search
                  value={query}
                  label="Find Farmers By Name or Phone"
                  onChangeText={handleChange}
                  onSubmit={handleOnSearch}
                />
              </div>
              {/* <div className="col-12 col-md-2">
                <div className="buttons">
                  <button
                    type="button"
                    className="button green"
                    onClick={handleOnFilter}
                  >
                    <FontAwesomeIcon icon={faFilter} className="button__icon" />
                    Filter
                  </button>
                </div>
              </div> */}
            </div>
            <div className="row">
              {pastHeld && pastHeld.paginate
                ? pastHeld.paginate.map((item) => (
                  <div className="col-12 col-lg-12">
                    <div className="card">
                      <div className="card__left">
                        <div className="card__avatar">
                          {
                            item?.profilePicture ? (<img src={item?.profilePicture} alt="order" />
                            ) : <img src={logoImg} alt="user" />

                          }
                        </div>
                        <div className="row between col-9">
                          <div className="card__text">
                            <div>
                              <span className="card__title">
                                Farmer Name :
                                {' '}
                              </span>
                              {item ? item?.farmerName : ''}
                            </div>
                            <div>
                              <span className="card__title">
                                Registration ID :
                                {' '}
                              </span>
                              {item ? item?.id : ''}
                            </div>
                            <div>
                              <span className="card__title">
                                Phone:
                                {' '}
                              </span>
                              {/* {item?.id ? item?.id : ''} */}
                              {item ? item?.phone : ''}

                            </div>
                            <div>
                              <span className="card__title">
                                Role:
                                {' '}
                              </span>
                              {/* {item?.id ? item?.id : ''} */}
                              MCC Farmer
                            </div>
                          </div>
                          <div className="card__text">
                            <div>
                              <span className="card__title">
                                User Created At :
                                {' '}
                              </span>
                              {moment(item?.createdAt).format('DD/MM/YYYY')}
                            </div>
                            <div>
                              <span className="card__title">
                                Plant Code :
                                {' '}
                              </span>
                              {item?.plantCode ?? 'N/A'}
                            </div>
                            <div>
                              <span className="card__title">
                                MCC Code :
                                {' '}
                              </span>
                              {item?.mccCode ?? 'N/A'}
                            </div>
                            <div>
                              <span className="card__title">
                                User Created Time :
                                {' '}
                              </span>
                              {moment(item?.createdAt).format('hh:mm a')}
                            </div>
                          </div>

                        </div>

                      </div>
                      <div className="card__right">
                        {item?.isNew && (
                        <span
                          className="count-ui"
                        >
                          NEW
                        </span>
                        )}
                        <div
                          className={`card__text--${item.farmerStatus === 'Active' ? 'success'
                            : item.farmerStatus === 'Inactive' ? 'danger' : 'primary'}`}
                        >
                          <span
                            className="card__title"
                          >
                            Status :
                            {' '}
                          </span>
                          {item.farmerStatus ?? 'Old user'}
                        </div>

                        <Link to={`/plant-admin/MccFarmerEditPage/${item?.id}`} className="card__button">View</Link>
                      </div>
                    </div>
                  </div>
                ))
                : (
                  null
                )}
              {!isLoading && !pastHeld?.paginate?.length && (
              <div className="col-12 col-lg-12 d-flex-col middle">
                <div className="notFound">
                  <FontAwesomeIcon icon={faCalendarAlt} className="notFound__icon" />
                  <span className="notFound__text">No past held users found</span>
                </div>
              </div>
              )}
            </div>
            {pastHeld?.paginate?.length > 0
              ? (
                <div className="row">
                  <div className="col-12 col-lg-12 d-flex-col middle">
                    <div className="pagination">
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!pastHeld.Previous}
                        onClick={() => previousPastHeldPage(pastHeld.Previous.page)}
                      >
                        <FontAwesomeIcon icon={faChevronLeft} className="pagination__btn__icon" />
                      </button>
                      <span className="pagination__page">
                        {pastHeld.Next
                          ? pastHeld.Next.page - 1
                          : pastHeld.Previous
                            ? pastHeld.Previous.page + 1
                            : 1}
                      </span>
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!pastHeld.Next}
                        onClick={() => nextPastHeldPage(pastHeld.Next.page)}
                      >
                        <FontAwesomeIcon icon={faChevronRight} className="pagination__btn__icon" />
                      </button>
                    </div>
                  </div>
                </div>
              ) : null}
          </TabPanel>
        </Tabs>
        {showModalForFilter ? (
          <ModalForFilter
            show={showModalForFilter}
            toggle={handleOnFilter}
            onSubmit={submitFilter}
            // values={data}
          />
        ) : null}
      </div>
      <LoadingModal show={isLoading} />
    </>
  );
};

export default withScreenRefreshDetection(MccFarmerListViewPage);
